import I18n from 'I18n';
import { SideNav } from 'foundations-components/transitional/components/SideNav';
import SetupGuideNavInviteLinkItem from './SetupGuideNavInviteLinkItem';
import SetupGuideNavProductItem from './SetupGuideNavProductItem';
import { useNavFooterItems } from './hooks/useNavFooterItems';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SetupGuideNavFooter = () => {
  const {
    shouldSeeNavFooter,
    showInviteLink,
    hasBillingPermissions,
    showTrialPickerLink,
    isLoadingTrials
  } = useNavFooterItems();
  if (!shouldSeeNavFooter) {
    return null;
  }
  return /*#__PURE__*/_jsxs(SideNav, {
    "aria-label": I18n.text('app.tabs.footerAriaLabel'),
    marginBlockEnd: "400",
    value: "",
    children: [/*#__PURE__*/_jsx(SetupGuideNavProductItem, {
      hasBillingPermissions: hasBillingPermissions,
      isLoadingTrials: isLoadingTrials,
      showTrialPickerLink: showTrialPickerLink
    }), /*#__PURE__*/_jsx(SetupGuideNavInviteLinkItem, {
      showInviteLink: showInviteLink
    })]
  });
};
export default SetupGuideNavFooter;